import {Component, Input} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-action-list-item',
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './action-list-item.component.html',
  styleUrl: './action-list-item.component.css'
})
export class ActionListItemComponent {
  @Input()
  label: string = ''
  @Input()
  url: string = '';
}
